export const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingTop: 4
	},
	button_group: {
		display: 'flex'
	},
	buttons: {
		marginRight: 1
	},
	title: {
		flexGrow: 1,
		fontWeight: 600
	}
};
